import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import FavoriteIcon from "@material-ui/icons/AccessAlarm";
import FetchIcon from "@material-ui/icons/ArrowDownward";
import { getFirestore } from "redux-firestore";
import Slider from "@material-ui/core/Slider";
import "./CookieWords.scss";

function valuetext(value) {
  return `${value}°C`;
}

export const CookieWords = (props) => {
  let wordsCookie = JSON.parse(localStorage.getItem("words"));
  const { ReplaceWords } = props;
  const [words, setWords] = useState(wordsCookie);

  const [value, setValue] = useState([100, 200]);
  const [max, setMax] = useState(wordsCookie ? wordsCookie.length : 10);

  //  const words = [];

  const updateWordCookie = (words) => {
    localStorage.setItem("words", JSON.stringify(words));
  };
  const updateParentWords = () => {
    ReplaceWords(words);
  };

  const getWordsFromDatabase = () => {
    let single_document = {};
    let data = [];
    let firestore = getFirestore();
    const limit = 1000;
    const collection = "word_set";

    firestore
      .collection(collection)
      .orderBy("createdAt", "desc")
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          single_document = doc.data();
          single_document.id = doc.id;
          data.push(single_document);
        });
        console.log(data);
        setWords(data);
        updateWordCookie(data);
        ReplaceWords(data);
      });
  };
  const handleChange = (event, newValue) => {
    console.log(newValue);
    const temp = wordsCookie.slice(newValue[0], newValue[1]);
    setWords(temp);
    setValue(newValue);
    ReplaceWords(temp);
  };
  return (
    <div className="cookie-words">
      <div className="flex">
        <Slider
          getAriaLabel={() => "Temperature range"}
          value={value}
          onChange={handleChange}
          valueLabelDisplay="auto"
          getAriaValueText={valuetext}
          max={max}
        />
        <div className="flex">
          {/* <IconButton onClick={() => updateParentWords()}>
            <FavoriteIcon></FavoriteIcon>
          </IconButton> */}
          <IconButton onClick={() => getWordsFromDatabase()}>
            <FetchIcon></FetchIcon>
          </IconButton>
        </div>
      </div>
    </div>
  );
};
